import React from 'react'

export const CourseProductWarning = () => {
  const warningLinkText = window.I18n.t('courses.product_warning_word')
  const warningText = window.I18n.t('courses.product_warning', { link: warningLinkText })
  const warningTextParts = warningText.split(warningLinkText)
  const warningLink = 'https://intercom.help/tournament-management/en/articles/10777048-how-can-i-update-my-golf-course-details'

  return(
    <div className='alert product_warning stick_to_breadcrumb'>
      <ul className='list-inline'>
        <li className='warning-note'>
          {window.I18n.t('courses.note')}:
        </li>
        <li className='warning-text-container'>
          <span>
            { warningTextParts[0] }
            <a href={ warningLink } target='_blank' rel='noopener noreferrer'>
              { warningLinkText }
            </a>
            { warningTextParts[1] }
          </span>
        </li>
      </ul>
    </div>
  )
}